import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { useRef } from "react";
import {
  useSessionActions,
  useSessionStore,
} from "../../../store/useSessionStore";
import ChatField from "./components/ChatField";
import MessagesComp from "./components/MessagesComp";
import WidgetsComp from "./components/WidgetsComp";
import useChatbotLifecycle from "./hooks/useChatbotLifecycle";
import useChatStream from "./hooks/useChatStream";
import {
  ChatBotWrapper,
  LoadingContainer,
  MainContainer,
  SubMainContainer,
  StyledEditorWrapper,
  EditorContainer,
  ReasoningTagContainer,
  ReasoningTag,
  StyledPromptGuideContainer,
} from "./style";
import { brighthiveTheme } from "../../../theme/theme";

export const ChatBot = () => {
  const reasoningEnabled = useSessionStore.use.reasoningEnabled();
  const loading = useSessionStore.use.loading();

  const { toggleReasoningEnabled } = useSessionActions();

  const { palette } = useTheme();

  const ref = useRef<HTMLButtonElement>(null);

  const { onSubmit, manualSubmit } = useChatStream();

  useChatbotLifecycle({ manualSubmit });

  return (
    <ChatBotWrapper className="ChatBot">
      <MainContainer>
        <SubMainContainer>
          {!loading ? (
            <>
              <WidgetsComp manualSubmit={manualSubmit} />
              <MessagesComp />
            </>
          ) : (
            <LoadingContainer>
              <CircularProgress sx={{ color: palette.primary.darkest }} />
            </LoadingContainer>
          )}
        </SubMainContainer>
      </MainContainer>
      <StyledEditorWrapper>
        <EditorContainer>
          <ReasoningTagContainer>
            <ReasoningTag
              size="small"
              icon={
                reasoningEnabled ? <TipsAndUpdatesIcon /> : <LightbulbIcon />
              }
              label="Reasoning"
              onClick={toggleReasoningEnabled}
              active={reasoningEnabled}
              variant={reasoningEnabled ? "filled" : "outlined"}
            />
          </ReasoningTagContainer>
          <ChatField onSubmit={onSubmit} ref={ref} />
        </EditorContainer>
        <StyledPromptGuideContainer>
          <a
            href="https://support.brighthive.io/articles/9496098577-brightagent-prompting-guide"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography
              variant="subtitle2"
              color={brighthiveTheme.palette.link.main}
            >
              Prompt Guide
            </Typography>
          </a>
        </StyledPromptGuideContainer>
      </StyledEditorWrapper>
    </ChatBotWrapper>
  );
};
